// extracted by mini-css-extract-plugin
export default {"label":"styles_label__7j8dr","span":"styles_span__qMU-O","input":"styles_input__SrOgX"};